/**
 * Created by Jie Gao on 2018-11-07.
 */
import { BetLinesView, IBetLinesViewConfig } from "@nolimitcity/slot-game/bin/core/betline/BetLinesView";
import { BetLineNumber } from "@nolimitcity/slot-game/bin/core/betline/BetLineNumber";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { ParsedInitData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ImmortalFruitsPolyBetLine} from "./line/ImmortalFruitsPolyBetLine";
import {IPolyBetLineConfig} from "@nolimitcity/slot-game/bin/game/betline/line/PolyBetLine";
import {TweenLite,TimelineLite} from "gsap";
import {BetLine} from "@nolimitcity/slot-game/bin/core/betline/BetLine";

export interface IWinLineConfig extends IPolyBetLineConfig {
    lineThickness?:number,
    circleSize?:number,
    baseColor?:number,
    outlineColor?:number,
    dynamicColor?:boolean,
    dynamicColors?:number[],
}
export class BetLineEvents {
    public static readonly SHOW_BETLINE_NUM: string = "BetLineEvents_SHOW_BETLINE_NUM";
    public static readonly SHOW_JACKPOT_ANIM: string = "BetLineEvents_SHOW_JACKPOT_ANIM";
    public static readonly KILL_ANIMATIONS: string = "BetLineEvents_KILL_ANIMATIONS";

}
export class ImmortalFruitsBetlinesView extends BetLinesView {
    private rightSideConfig = [49,46,27,40,34,42,45,41,39,35,33,28,47,43,38,36,32,30,26,50,48,44,37,31,29];
    private leftSideConfig = [ 1,7,12, 20,24, 25,2, 8,11,13,15,19, 3,6, 10,14,16, 18,23,4,5,9,17,21,22];
    private readonly _ssNumberFactoryMethod: (index: number) => BetLineNumber;
    private readonly _ssLineFactoryMethod: (index: number, numberPosition: number[], betLineData: number[]) => ImmortalFruitsPolyBetLine;
    private readonly _ssBetlineConfig: IBetLinesViewConfig;
    private _ssBetLinesData: number[][];
    private _tl:TimelineLite;
    private isAborted:boolean =false;
    constructor(config: IBetLinesViewConfig,
        numberFactoryMethod: (index: number) => BetLineNumber,
        lineFactoryMethod: (index: number, numberPosition: number[], betLineData: number[]) => ImmortalFruitsPolyBetLine) {

        super(config, numberFactoryMethod, lineFactoryMethod);
        this._ssNumberFactoryMethod = numberFactoryMethod;
        this._ssLineFactoryMethod = lineFactoryMethod;
        this._ssBetlineConfig = config;
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.parsedInitData(event.params[0]));
        EventHandler.addEventListener(this, BetLineEvents.SHOW_BETLINE_NUM, (event: GameEvent) => this.playLeftNumberAnimations());
        EventHandler.addEventListener(this, BetLineEvents.KILL_ANIMATIONS, (event: GameEvent) => this.killAllAnimations());
    }

    private parsedInitData(data: ParsedInitData): void {
        this._ssBetLinesData = data.betLines;
        if (this._ssBetLinesData.length != this._ssBetlineConfig.map.length) {
            debugger;
            throw new Error(`Error: There are only ${this._ssBetlineConfig.map.length} betLines in the config order while the server sends ${this._ssBetLinesData.length} lines.`);
        }
        this._dataInitialized = true;
        this.draw();
    }

    protected draw(): void {
        if (!this._resourcesLoaded || !this._dataInitialized) {
            return;
        }
        const map: number[] = this._ssBetlineConfig.map;
        const numNumbers: number = map.length;
        for (let i: number = 0; i < numNumbers; i++) {
            const betLineNumber: BetLineNumber = this._ssNumberFactoryMethod(map[i]);
            const betLineNumberPosition: number[] = betLineNumber.setPosition(this._ssBetLinesData.length, i);
            this._betLineNumbers.push(betLineNumber);
            const betLine: ImmortalFruitsPolyBetLine = this._ssLineFactoryMethod(map[i], betLineNumberPosition, this._ssBetLinesData[map[i] - 1]);
            this._betLines.push(betLine);
        }
        this._betLines.sort((a: BetLine, b: BetLine) => {
            return a.index - b.index;
        });
        this._betLineNumbers.sort((a: BetLineNumber, b: BetLineNumber) => {
            return a.index - b.index;
        });

        //this.();
    }
    private playLeftNumberAnimations(){
        this.isAborted =false;
        this._tl= new TimelineLite();
         this.leftSideConfig.forEach((value, index)=>{
                this._tl.add(()=>{
                    let betLineIndx= this.findIndexOfBetline(value);
                    if(betLineIndx!==-1 && !this.isAborted ){
                        this.highlightBetNum(betLineIndx);
                    }
                },(index)*0.02);
                this._tl.add(()=>{
                    let betLineIndx= this.findIndexOfBetline(value);
                    if(betLineIndx!==-1 && !this.isAborted ){
                        this.dimBetNum(betLineIndx);
                    }
                },(index+4)*0.02);
        });
        this.rightSideConfig.forEach((value,index)=>{
            this._tl.add(()=>{
                    let betLineIndx= this.findIndexOfBetline(value);
                    if(betLineIndx){
                        this.highlightBetNum(betLineIndx);
                    }
                },(24+index)*0.02);
            this._tl.add(()=>{
                let betLineIndx= this.findIndexOfBetline(value);
                if(betLineIndx && !this.isAborted ){
                    this.dimBetNum(betLineIndx);
                }
            },(index+24+4)*0.02);

        });
         }
        private findIndexOfBetline(betLineNum:number):number{

        let betLineIndx = -1;
             this._betLineNumbers.forEach((value,index)=>{
                 if(betLineNum===value.index){
                     betLineIndx = index;
                     return index;
                 }else{
                     return -1;
                 }
             });
             return betLineIndx;
        }
        private highlightBetNum(index:number){

            TweenLite.fromTo(this._betLineNumbers[index].children[1], 0.02, {alpha:1}, {alpha:0});
            TweenLite.fromTo(this._betLineNumbers[index].children[2], 0.02, {alpha:0}, {alpha:1});

        }
        private dimBetNum(index:number){
            TweenLite.fromTo(this._betLineNumbers[index].children[1], 0.02, {alpha:0}, {alpha:1});
            TweenLite.fromTo(this._betLineNumbers[index].children[2], 0.02, {alpha:1}, {alpha:0})

        }
        private killAllAnimations(){
          this.isAborted =true;

          this._tl && this._tl.clear();
          this._betLineNumbers.forEach((value,index)=>{
              this._betLineNumbers[index].children[1].alpha=1;
              this._betLineNumbers[index].children[2].alpha=0;
            });
        }

}